export const isDateValid = (date) =>{
    return date instanceof Date && !isNaN(date);
}